import { Link } from 'react-router-dom';
import SubscribeForm from '@/components/feature/SubscribeForm';
import { siteNav } from '@/mocks/nav';
import { categories } from '@/mocks/categories';
import { SITE_META } from '@/hooks/useSeo';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 rounded-md flex items-center justify-center bg-primary-500 text-background-50 text-xl">
                <i className="ri-radar-line" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">爆料专区导航</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200 max-w-md">
              把爆料专区的首页入口、网址网页与热门讨论区整理成清晰指南，让你不用四处搜索，也能快速找到第一手资讯与正在发酵的话题。
            </p>
            <div className="mt-6 max-w-md" id="subscribe">
              <p className="text-xs tracking-widest text-accent-400 mb-2.5">每周更新订阅</p>
              <SubscribeForm variant="dark" />
              <p className="mt-2.5 text-xs text-secondary-300">
                每周一封更新汇总，只发重点，可随时取消。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">
                站点导航
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {siteNav.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-secondary-200 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/topics" className="hover:text-accent-400 transition-colors cursor-pointer">
                主题专区
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(1, 7).map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/topics?category=${item.id}`}
                    className="text-sm text-secondary-200 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
                关于与联系
              </Link>
            </h4>
            <ul className="space-y-3 text-sm text-secondary-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                <span className="break-all">{SITE_META.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" />
                <span>内容每日维护 · 汇总每周推送</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-accent-400" />
                <span>本站为信息导航站点，内容仅供参考。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">© 2026 爆料专区导航 · 保留所有权利</p>
          <p className="text-xs text-secondary-300">请理性浏览，重要信息请以官方发布为准。</p>
        </div>
      </div>
    </footer>
  );
}